import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { User } from 'src/app/shared/interfaces/user.interface';
import { getFileUrl } from 'src/app/utils/getFileUrl';
import { MembersService } from '../members.service';

@Component({
  selector: 'app-member-view',
  templateUrl: './member-view.component.html',
  styleUrls: ['./member-view.component.css'],
})
export class MemberViewComponent implements OnInit {
  id: string;
  member: User;
  profileImage: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private memberService: MembersService,
    private loadService: LoaderService
  ) {
    this.activatedRoute.params.subscribe((params) => {
      if (params.id) {
        this.id = params.id;
        this.get();
      }
    });
  }

  ngOnInit(): void {}

  getChurchStatusDisplay(status: string): string {
    switch (status) {
      case 'novo_convertido': return 'Novo convertido';
      case 'membro': return 'Membro';
      case 'visitante_de_celula': return 'Visitante de célula';
      default: return 'Não informado';
    }
  }

  get(): Promise<any> {
    this.loadService.showLoader();
    return this.memberService
      .getById(this.id)
      .then((res) => {
        this.member = res;
        this.profileImage = getFileUrl(res);
        this.loadService.closeLoader();
      })
      .catch(() => {
        this.loadService.closeLoader();
      });
  }
}
